export default "__VITE_ASSET__BFApp5su__"